<template>
  <div class="media-crop-component">
    <hi-dialog :title="title" class="crop-dialog" @close="close">
      <div class="main-container">
        <!--<div class="type-container">-->
        <!--<div class="type-item">-->
        <!--<div class="icon filter"></div>-->
        <!--<div class="text">Filter</div>-->
        <!--</div>-->
        <!--</div>-->
        <div class="filter-type-container">
          <div
            v-for="filter in filterTypes"
            :key="filter.type"
            class="filter-item"
            @click="changeFilter(filter)"
            :class="{
              select: mediaList[imageSelectIndex].crop.filter === filter.type,
            }"
          >
            <media-crop-thumbnails
              :filter="filter.type"
              :model="mediaList[imageSelectIndex]"
            ></media-crop-thumbnails>
          </div>
        </div>
        <div class="crop-container">
          <div class="crop-main-container">
            <media-crop-thumbnails
              v-for="(image, index) in mediaList"
              v-if="index === imageSelectIndex"
              :key="image.url"
              :model="image"
              backgroundColor="#595959"
              class="crop-img-container"
            ></media-crop-thumbnails>
          </div>
          <div>
            <div class="crop-thumbnail-container">
              <div v-for="(image, index) in mediaList" :key="image.url">
                <media-crop-thumbnails
                  @click.native="imageSelectClick(index)"
                  :key="image.url"
                  :model="image"
                  class="image-thumbnail"
                  backgroundColor="#505050"
                  :class="{ 'image-selected': index === imageSelectIndex }"
                ></media-crop-thumbnails>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <hi-button style="width: 98px" type="text" @click.native="close"
          >Cancel</hi-button
        >
        <hi-button @click.native="saveClick" style="width: 98px"
          >Save</hi-button
        >
      </div>
    </hi-dialog>
  </div>
</template>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import hiButton from "../../common/button/Index";
import MediaCropThumbnails from "./Thumbnail";
import _ from "lodash";
export default {
  name: "MediaCropGroupComponent",
  components: { hiDialog, hiButton, MediaCropThumbnails },
  props: {
    images: {
      // 显示图片
      type: Array,
      required: true,
    },
    type: {
      // 类型 filter(滤镜)
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * 图片选中的索引位置
     * @param index 选中图片位置
     */
    imageSelectClick(index) {
      this.imageSelectIndex = index;
    },
    /**
     * 删除图片
     */
    removeImage(index) {
      // 判断选中项是否为最后一项
      if (this.mediaListN.length - 1 === this.imageSelectIndex) {
        this.imageSelectIndex--;
      }
      this.mediaList.splice(index, 1);
    },
    /**
     * 关闭按钮回调
     */
    close() {
      this.$emit("close");
    },
    /**
     * 保存按钮点击事件
     */
    saveClick() {
      // 保存对于图片的操作
      this.$set(this.$parent, "images", this.mediaList);
      this.$emit("close");
    },
    changeFilter(filter) {
      this.mediaList[this.imageSelectIndex].crop.filter = filter.type;
    },
  },
  computed: {
    title() {
      if (this.type === "filter") {
        return "Filter";
      }
    },
  },
  data() {
    return {
      imageSelectIndex: 0, // 选中的图片
      mediaList: [],
      filterTypes: [
        { name: "normal", type: "normal" },
        { name: "clarendon", type: "clarendon" },
        { name: "lark", type: "lark" },
        { name: "gingham", type: "gingham" },
        { name: "valencia", type: "valencia" },
        { name: "xpro2", type: "xpro2" },
        { name: "lofi", type: "lofi" },
      ],
    };
  },
  created() {
    // 复制一下图片等确认之后再覆盖
    this.mediaList = _.cloneDeep(this.images);
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme";

.media-crop-component {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  .crop-dialog {
    min-height: auto;
    max-height: initial;
  }
  .main-container {
    display: flex;
    flex: 1;

    .type-container {
      width: 140px;
      border-right: 1px solid #e6e6e6;

      .type-item {
        height: 56px;
        display: flex;
        align-items: center;
        border-right: 3px solid transparent;
        font-size: 14px;
        padding-left: 15px;
        cursor: pointer;

        .icon {
          width: 25px;
          height: 25px;
          background-size: contain;
          margin-right: 10px;

          &.filter {
            background-image: url("../../../../public/images/crop/Edit_Media__Filters_M@3x.png");
          }
        }

        &.select,
        &:hover {
          color: @color-primary;
          border-right-color: @color-primary;

          .icon.filter {
            background-image: url("../../../../public/images/crop/Edit_Media__Filters_S_@3x.png");
          }
        }

        &:hover {
          border-right-color: transparent;
        }

        .text {
        }
      }
    }

    .filter-type-container {
      width: 140px;
      border-right: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow: auto;

      .filter-item {
        width: 70px;
        height: 70px;
        border: 3px solid transparent;
        margin-top: 15px;
        cursor: pointer;

        &.select {
          border-color: @color-primary;
        }
      }
    }
  }
  .crop-container {
    width: 580px;
    display: flex;
    flex-direction: column;

    .crop-main-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      background: rgb(89, 89, 89);
      .crop-img-container {
        width: 450px;
        height: 450px;
      }
    }

    .crop-thumbnail-container {
      height: 100px;
      padding: 5px 15px;
      background: #505050;
      overflow: auto;
      white-space: nowrap;
      display: flex;

      .image-thumbnail {
        margin: 5px;
        width: 80px;
        height: 80px;
        border: 3px solid #505050;
        cursor: pointer;
        &.image-selected {
          border: 3px solid white;
        }

        .mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;

          .icon {
            position: absolute;
            right: 3px;
            top: 3px;
            color: white;
            height: 15px;
            width: 15px;
            background-position: center;
            background-size: contain;
            background-image: url("../../../../public/images/crop/Close.png");
            background-repeat: no-repeat;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bottom-container {
    height: 64px;
    border-top: 1px solid #e6e6e6;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
  }
}
</style>
